export const childGenderParser: Readonly<Record<'man' | 'woman', string>> = {
    man: 'boy',
    woman: 'girl',
};
